const productAliasMap = {
    'personal_loan_with_banking': 'personal_loan',
    // add more aliases if needed
};

export function resolveProductName(alias) {
    // if alias is not a string, return default product
    if (typeof alias !== 'string') {
        return 'personal_loan';
    }

    return productAliasMap[alias.toLowerCase()] ?? alias;
}
